const type = 'SET_AGREEMENT_DUE_DATES';

const setAgreementDueDates = (data) => ({
  data,
  type,
});

export { type };
export default setAgreementDueDates;
